import { Component as CookieBanner } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/cookie-banner-component';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useCookies } from '@fans-fund-me/shared-common-esm-cookies';
import { useCurrency } from '@fans-fund-me/shared-common-esm-currency';
import { useDisclosure } from '@mantine/hooks';
import { Notifications } from '@mantine/notifications';
import { useEffect } from 'react';
import { RouterProvider } from 'react-router';
import { AxiosInterceptors } from '../api/client.ts';
import router from '../navigation/Router';
import useRunOnce from '../utils/RunOnce.ts';

export const Navigation = () => {
  const auth = useAuth();
  const currency = useCurrency();
  const cookies = useCookies();

  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    if (!cookies.arePermissionsSet && cookies.permissions === undefined) {
      open();
    }
  }, [cookies.arePermissionsSet, cookies.permissions, open]);

  useEffect(() => {
    if (auth.isLoggedIn && auth.details['currency'] !== undefined && auth.details['currency'] !== currency.value) {
      currency.setCurrency(auth.details['currency']);
    }
  }, [auth, currency]);

  useRunOnce({
    fn: () => {
      AxiosInterceptors({ userId: auth.id, logout: auth.logout });
    },
  });

  return (
    <>
      <RouterProvider router={router} />
      <Notifications />
      {!cookies.arePermissionsSet && (
        <CookieBanner
          opened={opened}
          close={close}
          handleClickAll={cookies.acceptAll}
          handleClickNecessary={cookies.acceptNecessary}
        />
      )}
    </>
  );
};
